var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isGetting && Object.keys(_vm.watchingMovies).length > 0)?_c('div',{staticClass:"watching"},[_c('h2',{staticClass:"watching__title"},[_vm._v("Đang theo dõi")]),_c('movie-slider',{attrs:{"movies":_vm.watchingMovies}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }